// store/documentSlice.ts
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AnalysisResults } from '../types';
import { API_URL } from '../utils/config';

interface DocumentState {
 documents: AnalysisResults[];
 currentDocument: AnalysisResults | null;
 loading: boolean;
 error: string | null;
}

const initialState: DocumentState = {
 documents: [],
 currentDocument: null,
 loading: false,
 error: null,
};

// Async thunks for API calls
export const fetchDocuments = createAsyncThunk(
 'documents/fetchAll',
 async () => {
   const response = await fetch(`${API_URL}/api/documents`);
   const data = await response.json();
   return data;
 }
);

export const fetchDocumentById = createAsyncThunk(
 'documents/fetchById',
 async (id: number) => {
   const response = await fetch(`${API_URL}/api/documents/${id}`);
   const data = await response.json();
   return data;
 }
);

const documentSlice = createSlice({
 name: 'documents',
 initialState,
 reducers: {
   setCurrentDocument: (state, action: PayloadAction<AnalysisResults | null>) => {
     state.currentDocument = action.payload;
   },
   clearError: (state) => {
     state.error = null;
   }
 },
 extraReducers: (builder) => {
   builder
     // Handle fetchDocuments
     .addCase(fetchDocuments.pending, (state) => {
       state.loading = true;
       state.error = null;
     })
     .addCase(fetchDocuments.fulfilled, (state, action) => {
       state.loading = false;
       state.documents = action.payload;
     })
     .addCase(fetchDocuments.rejected, (state, action) => {
       state.loading = false;
       state.error = action.error.message || 'Failed to fetch documents';
     })
     // Handle fetchDocumentById
     .addCase(fetchDocumentById.pending, (state) => {
       state.loading = true;
       state.error = null;
     })
     .addCase(fetchDocumentById.fulfilled, (state, action) => {
       state.loading = false;
       state.currentDocument = action.payload;
     })
     .addCase(fetchDocumentById.rejected, (state, action) => {
       state.loading = false;
       state.error = action.error.message || 'Failed to fetch document';
     });
 }
});

export const { setCurrentDocument, clearError } = documentSlice.actions;
export default documentSlice.reducer;